var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"app":""}},[_c('v-overlay',{attrs:{"opacity":"1","color":"mainbg"},model:{value:(_vm.isError),callback:function ($$v) {_vm.isError=$$v},expression:"isError"}},[_c('errorNotFoundComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }